import { useNavigate } from 'react-router-dom';
import { TokenUsagePanel } from '@/components/ai';
import { Button } from '@/components/ui/Button';

export function TokenUsageDashboardPage() {
  const navigate = useNavigate();

  return (
    <div className="container max-w-5xl py-6">
      <div className="mb-6 flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Painel de Custos IA</h1>
          <p className="text-gray-500 mt-1">Métricas de uso, latência e custo dos provedores</p>
        </div>
        <Button variant="outline" onClick={() => navigate(-1)}>Voltar</Button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <TokenUsagePanel provider="stub" sinceHours={24} />
        <TokenUsagePanel provider="stub" sinceHours={168} />
      </div>

      <div className="mt-6 bg-white rounded-xl border border-gray-200 p-5">
        <h2 className="font-semibold text-gray-900 mb-3">Observabilidade</h2>
        <ul className="text-sm text-gray-700 space-y-2 list-disc list-inside">
          <li>Métricas registradas por agente (Triage, Copilot, Scribe, Timeline, Alerts, Summary)</li>
          <li>Latência calculada em milissegundos por chamada</li>
          <li>Tokens consumidos (entrada, saída, total) rastreados por conversa</li>
          <li>Custos calculados pelo provider via <code>calculateCost()</code></li>
          <li>Eventos de fallback emitidos para monitoria</li>
          <li>Audit log completo em <code>AI_AUDIT</code> e <code>AI_LOG</code></li>
        </ul>
      </div>
    </div>
  );
}